import { APIConnectionRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getApiConnectionUsers, getApiConnections, getUserId, getUsers
} from './common';

const getApiConnectionId = (_: AdminState | ClientState, apiConnectionId: string) => apiConnectionId;

export const getApiConnectionsArray = createSelector(getApiConnections, (apiConnections) => {
    return Object.keys(apiConnections)
        .map(id => apiConnections[id])
        .filter(api => !api.IsDeleted);
});

export const getApiConnectionsByClient = createSelector(
    [ getUserId, getApiConnectionUsers, getApiConnections, getUsers ],
    (userId, apiConnectionUsers, apiConnections, users) => {
        if (!userId || !apiConnections || !apiConnectionUsers) return;

        const userConnectionIds = Object.keys(apiConnectionUsers)
            .map(id => apiConnectionUsers[id])
            .filter(userConn => userConn.UserId === userId && !userConn.IsDeleted);

        const userApiConnections = userConnectionIds.map(connId => ({
            apiConnection: { ...apiConnections[connId.APIConnectionId] },
            apiUser: { ...connId },
            user: { ...users[connId.UserId] }
        }));

        return userApiConnections;
    }
);

export const getAPIConnectionById = createSelector(
    [ getApiConnections, getApiConnectionId ],
    (apiConnections, apiConnectionId): APIConnectionRecord => apiConnections[apiConnectionId] || {} as APIConnectionRecord
);